import { render } from "./PlanosManager.vue?vue&type=template&id=5b8f6c3f&scoped=true"
import script from "./PlanosManager.vue?vue&type=script&lang=js"
export * from "./PlanosManager.vue?vue&type=script&lang=js"

import "./PlanosManager.vue?vue&type=style&index=0&id=5b8f6c3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8f6c3f"]])

export default __exports__